<template>
  <section>
    <p>
      <strong>{{ $t('course.detail.label.name') }} : </strong><br>
      {{ course.title_full_name }}
    </p>
    <p>
      <strong>{{ $t('course.detail.label.time') }} : </strong><br>
      <span class="d-inline-block" v-if="course.enddate && course.enddate.substr(0, 10) === course.spkdate.substr(0, 10)">
        {{ course.spkdate.substr(0, 10) }}&nbsp;
      </span>
      <span class="d-inline-block" v-else>
        {{ getHumanReadableForWeekNumber(course.week_number) }}&nbsp;
      </span>
      <span class="d-inline-block">
        {{ days_of_week[course.week == 7 ? 0 : course.week] }}&nbsp;
      </span>
      <span class="d-inline-block">
        {{ course.spk_start_time }} ~ {{ course.spk_end_time }}
      </span>
    </p>
    <p>
      <strong>{{ $t('course.detail.label.place') }} : </strong><br>
      <span v-for="place in course.places">{{ place.name }}&nbsp;&nbsp;&nbsp;</span>
    </p>
    <p v-if="course.lecturer">
      <strong>{{ $t('course.detail.label.lecturer') }} : </strong><br>
      {{ course.lecturer.lecr_full_name }}
    </p>
    <p v-if="course.intro">
      <strong>{{ $t('course.detail.label.introduction') }} : </strong><br>
      <span v-html="course.intro"></span>
    </p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
  </section>
</template>

<script>
import Vue from 'vue'

import i18n from '@/plugins/i18n.js'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

export default {
  i18n,
  name: 'course-info',
  props: {
    course: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      numbers_of_week: {
        '-5': '隔五週', '-4': '隔四週', '-3': '隔三週', '-2': '隔二週', '-1': '隔週',
        '0': '每週',
        '1': '第一週', '2': '第二週', '3': '第三週', '4': '第四週', '5': '第五週'
      },
      days_of_week: ['星期日', '星期一' , '星期二', '星期三', '星期四', '星期五', '星期六']
    }
  },
  computed: {
    social_sharing_title() {
      return `${this.course.title_full_name} ${this.course.lecturer.lecr_full_name}`
    },
    social_sharing_route() {
      return { name: 'course', params: { id: this.course.id } }
    }
  },
  methods: {
    getHumanReadableForWeekNumber(week_number) {
      let return_value = week_number
        .map(item => this.numbers_of_week[item])
        .join('、')
      return week_number.every(item => parseInt(item) > 0)
        ? `每月${return_value}`
        : return_value
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.course && this.course.id) {
      gtag('event', `browse course`, {
        code: this.course.id,
        name: this.course.title_full_name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }  
}
</script>